// Premium collectors theme with metallic accents and luxury colors
export const forgeTheme = {
  colors: {
    // Primary colors - Deep blues and blacks for premium feel
    primary: '#0A1929', // Deep navy/black
    secondary: '#1E3A5F', // Rich deep blue
    tertiary: '#2C5282', // Medium blue
    
    // Background colors
    background: {
      dark: '#0A0E17',  // Deep black with blue tint
      light: '#F8F9FA',  // Soft white
      medium: '#1A2332', // Dark blue-gray
      card: '#FFFFFF',   // Pure white for cards
    },
    
    // Metallic accent colors - Gold and Silver
    metallic: {
      gold: '#D4AF37',      // Rich gold
      goldLight: '#F4E4B7', // Light gold
      goldDark: '#B8941E',  // Dark gold
      silver: '#C0C0C0',    // Silver
      silverLight: '#E8E8E8', // Light silver
      silverDark: '#A0A0A0',  // Dark silver
      bronze: '#CD7F32',    // Bronze
      platinum: '#E5E4E2',  // Platinum
    },
    
    // Accent colors
    accent: {
      copper: '#B87333', // Copper metal
      steel: '#71797E',  // Steel/iron
      crimson: '#C41E3A', // Accent crimson
      orange: '#E25822',  // Molten orange
    },
    
    // Text colors
    text: {
      primary: '#FFFFFF',  // White text
      secondary: '#E0E0E0', // Light gray text
      dark: '#0A1929',     // Dark text
      muted: '#6B7280',    // Muted text
      gold: '#D4AF37',     // Gold text
    },
    
    // Status colors
    status: {
      success: '#10B981',
      error: '#EF4444',
      warning: '#F59E0B',
      info: '#3B82F6',
    },
    
    // Border colors
    border: '#E5E7EB',
    borderDark: '#374151',
  },
  
  // Typography
  fonts: {
    primary: "'Roboto', sans-serif",
    secondary: "'Montserrat', sans-serif",
    heading: "'Cinzel', serif", // More decorative font for headings
  },
  
  // Font sizes
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.25rem',
    xl: '1.5rem',
    xxl: '2rem',
    xxxl: '3rem',
  },
  
  // Spacing
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    xxl: '3rem',
  },
  
  // Breakpoints for responsive design
  breakpoints: {
    xs: '320px',
    sm: '576px',
    md: '768px',
    lg: '992px',
    xl: '1200px',
  },
  
  // Border radius
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '16px',
    round: '50%',
  },
  
  // Shadows - Enhanced for premium feel
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 4px 8px rgba(0, 0, 0, 0.12)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.15)',
    xl: '0 12px 24px rgba(0, 0, 0, 0.2)',
    gold: '0 4px 12px rgba(212, 175, 55, 0.3)',
    silver: '0 4px 12px rgba(192, 192, 192, 0.3)',
  },
  
  // Transitions
  transitions: {
    fast: '0.15s ease',
    short: '0.2s ease',
    medium: '0.3s ease',
    long: '0.5s ease',
    slow: '0.8s ease',
  },
  
  // Gradients
  gradients: {
    gold: 'linear-gradient(135deg, #D4AF37 0%, #F4E4B7 50%, #D4AF37 100%)',
    silver: 'linear-gradient(135deg, #C0C0C0 0%, #E8E8E8 50%, #C0C0C0 100%)',
    darkBlue: 'linear-gradient(135deg, #0A1929 0%, #1E3A5F 100%)',
    premium: 'linear-gradient(135deg, #0A1929 0%, #1E3A5F 50%, #2C5282 100%)',
  },
};
